/**
 * @memberof SMART2
 * @ngdoc directive
 * @name Popup
 * @description This directive is useful for creating a popup.
 * 
 * @attr {String} template-url
 *    Template url that is expected to appear as popup contents
 * @attr {Boolean} show
 *    Popup will toggle as soon as value of this attribute changes
 * @attr {String} modal-type
 *    Modal type. Possible values are 'large' or 'small'.
 * @attr {Boolean} dismissible
 *   If set to true, popup will not hide when clicked outside. Default value is true.
 * @attr {Function} on-hide
 *    Callback function when popup hides
 * 
 * @example
 Controller:
 $scope.showPopup = false;
 $scope.onPopupHide = function() {
      $scope.showPopup = false;
 };
Usage:
 <smart-popup template-url="abc.html" show="{{showPopup}}" on-hide="onPopupHide()"></smart-popup>
 <button ng-click="showPopup=true">Click here</button>
 */

(function () {
    'use strict';
    angular.module('SMART2').directive('smartPopup', ['$rootScope', '$parse', '$timeout', '$smartModal', '$focusOnField', function ($rootScope, $parse, $timeout, $smartModal, $focusOnField) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            controller: ["$controller", "$scope", "$attrs", "$scoper", function ($controller, $scope, $attrs, $scoper) {
                var _scope = $scope,
                    ctrl,
                popupConfig = $scoper.getScope(_scope, $attrs.popupConfig);

                if (popupConfig) {
                    if (popupConfig.controller) {
                        var launchObj = {
                            $scope: _scope
                        };
                        if (popupConfig.resolve) {
                            var val;
                            angular.forEach(popupConfig.resolve, function (value, key) {
                                if (typeof value == "function") {
                                    val = value();
                                } else {
                                    val = value;
                                }
                                this[key] = val;
                            }, launchObj);
                        }
                        ctrl = $controller(popupConfig.controller, launchObj);
                        ctrl.$$smartModal = true;
                    }
                } else {
                    ctrl = _scope;
                };
                return ctrl;
            }],
            link: function (scope, element, attrs, controller) {

                var onHide = $parse(attrs.onHide),
                    triggeredElement;
                // Callback for complete popup close i.e this callback executes after popup animation over.
                if (attrs.afterCompleteClosePopup) {
                    var afterCompleteClosePopup = $parse(attrs.afterCompleteClosePopup);
                }

                var topPositionBeforeModalOpen = 0;

                scope.isCancelButton = (attrs.cancelButton) ? scope.$eval(attrs.cancelButton) : false;

                scope.headerUrl = attrs.headerUrl;
                scope.contentUrl = attrs.contentUrl;
                scope.footerUrl = attrs.footerUrl;
                scope.templateUrl = attrs.templateUrl;
                scope.modalType = attrs.type;
                scope.isDraggable = attrs.isDraggable;

                //Cleaning floating elements on drag
                function cleanFloatingElements() {
                    element.find("[id^=typeahead-]").each(function (i, el) {
                        var autoComplete = $(this).data().autocomplete;
                        if (autoComplete && autoComplete.visible) {
                            autoComplete.hide();
                        }
                    });
                }
                //End of cleaning floating elements on drag

                if (scope.isDraggable) {
                    angular.element(element).draggable({
                        start: function () {
                            cleanFloatingElements();
                        },
                        containment: ".is-popup-Draggable"
                    });
                };


                attrs.$observe('expandCollapse', function (value) {
                    scope.expandCollapse = value;
                    setTimeout(function () {

                        angular.element(scope.expandCollapse).click(function () {
                            angular.element(scope.expandCollapse).closest('.modal').addClass('expand-css-trans');
                            setTimeout(function () {
                                angular.element(scope.expandCollapse).closest('.modal .modal-header').toggleClass('extra-nav-wrap expand-header expand-css-trans');
                            }, 500);

                            setTimeout(function () {
                                angular.element(scope.expandCollapse).closest('.modal').removeClass('expand-css-trans');
                            }, 200);

                            angular.element(scope.expandCollapse).closest('.modal').toggleClass('expand-css');
                            angular.element(scope.expandCollapse).parent('.modal-header').next().next('.modal-footer_new').find('.modal-close').click(function () {
                                angular.element(scope.expandCollapse).closest('.modal').removeClass('expand-css');
                                angular.element(scope.expandCollapse).closest('.modal .modal-header').removeClass('extra-nav-wrap expand-header expand-css-trans');
                                angular.element(scope.expandCollapse).parents('body').find('.lean-overlay').css('display', 'block');
                            });
                            if (angular.element(scope.expandCollapse).closest('.modal').hasClass('expand-css')) {
                                angular.element(scope.expandCollapse).parents('body').find('.lean-overlay').css('display', 'none');
                                angular.element(scope.expandCollapse).closest('.modal').css('border-radius', '0');
                            }
                            else {
                                angular.element(scope.expandCollapse).parents('body').find('.lean-overlay').css('display', 'block');
                            }
                        });
                    }, 1000);
                });


                /*
                 *  Unbind window keyup listener and assign tabindex back to .picker elements
                 */
                var reset = function () {
                  //  $(window).off('keyup', onWindowKeyUp);
                    angular.element('.picker').attr("tabindex", 0);
                    //COMMENTED: TWO-5672 impact   angular.element(document).scrollTop(topPositionBeforeModalOpen);
                };


                /*
                 *  window on key up event listener
                 */
                //var onWindowKeyUp = function (e) {
                //    if (angular.element(e.target).closest('.modal').length == 0 && e.keyCode == 9) {
                //        angular.element(element.find(':focusable')[0]).focus();
                //    }
                //};


                /*
                 * Show pop up
                 */
                var $popup, onShow = attrs.$observe('show', function (value) {
                    if (angular.isDefined(value)) {
                        if (scope.$eval(value)) {
                            triggeredElement = document.activeElement;
                            angular.element(triggeredElement).addClass('currentPopupTriggerer');
                            topPositionBeforeModalOpen = angular.element(document).scrollTop();
                            angular.element(element).openModal({
                                dismissible: scope.$eval(attrs.dismissible),
                                beforeOpen: function () {
                                    $popup = angular.element(element).data();
                                    if (scope.isDraggable) {
                                        angular.element('body').addClass('is-popup-Draggable');
                                    }
                                },
                                complete: function () {
                                    if (angular.isFunction(onHide)) {
                                        scope.$apply(function () {
                                            onHide(scope, { e: "" });
                                        });
                                    }
                                    reset();

                                    //  Check if popup is opened by uigrid-compatible element
                                    if (window.isPopupOpenedByUIGridCompatibleElement) {
                                        //  Following event is listened inside uigrid-compatible dir
                                        $rootScope.$emit("popupClosed");
                                        window.isPopupOpenedByUIGridCompatibleElement = undefined;
                                    }

                                    if (element.hasClass("noTransform")) {
                                        var toutpromise = setTimeout(function () {
                                            element.css('top', 0).removeClass('noTransform');
                                            clearTimeout(toutpromise);
                                            toutpromise = null;
                                        }, 100);
                                    }
                                },
                                ready: function () {
                                    //  Check if popup is opened by uigrid-compatible element
                                    if (window.isPopupOpenedByUIGridCompatibleElement) {
                                        $rootScope.$emit("popupOpened");
                                    }
                                    $timeout(function () {
                                        if (scope.isDraggable) {
                                            var bodyHeight = angular.element('body').height() / 2,
                                             modalHeight = angular.element('.modal.ui-draggable').height() / 2,
                                            bodyWidth = angular.element('body').width() / 2,
                                            modalWidth = angular.element('.modal.ui-draggable').width() / 2;

                                            $(element).css({ 'position': "absolute", 'top': (bodyHeight - modalHeight) / 2, 'margin': 0, 'left': (bodyWidth - modalWidth) });
                                        }
                                        else {
                                            var t = window.innerHeight / 2 - element.outerHeight() / 2;
                                            element.css('top', t);
                                        };
                                        $(element).addClass('noTransform');

                                        //Auto focus first feild / manage tab index
                                        angular.element(element.find(':focusable').not('.select-dropdown')[0]).not('.datepicker').focus();

                                      //  $(window).on('keyup', onWindowKeyUp);

                                        //Remove picker tabindex when popup to avoid focus on picker element
                                        angular.element('.picker').removeAttr("tabindex");
                                    });
                                    $timeout(function () {
                                        var $firstField = element.find("a, input[type=text],input[type=radio]:checked,input[type=checkbox], button, textarea, [tabindex='0']").not(":disabled, :hidden, [tabindex = -1]").first();
                                        $focusOnField($firstField);
                                    }, 600);
                                }
                            });
                        }
                        else {
                            var el = angular.element(element),
                                isPopupInit = el.data("overlay-id") === undefined ? false : true;

                            // isPopupInit variable is used  to check whether popup is initiated or not.
                            if (isPopupInit) {
                                el.closeModal({
                                    complete: function () {
                                        if (attrs.afterCompleteClosePopup)
                                            afterCompleteClosePopup(scope, {});

                                        if (scope.isDraggable) {
                                            angular.element('body').removeClass('is-popup-Draggable');
                                        }
                                        if (controller.$$smartModal === true) {
                                            $smartModal.destroyModal({ $view: el, $scope: scope });
                                        }
                                        angular.element(".currentPopupTriggerer").focus().removeClass('currentPopupTriggerer');
                                        triggeredElement = null;
                                    }
                                });

                                if (element.hasClass("noTransform")) {
                                    var tOutTemp = setTimeout(function () {
                                        element.css('top', 0).removeClass('noTransform');
                                        clearTimeout(tOutTemp);
                                        tOutTemp = null;
                                    }, 100);
                                }
                            }
                            //  remove the listener and add tabindex back on picker
                            reset();

                            //  Check if popup is opened by uigrid-compatible element
                            if (window.isPopupOpenedByUIGridCompatibleElement) {
                                //  Following event is listened inside uigrid-compatible dir
                                $rootScope.$emit("popupClosed");
                                window.isPopupOpenedByUIGridCompatibleElement = undefined;
                            }
                        }
                    }
                });

                scope.$on('$destroy', function () {
                    onShow();
                    reset();
                    if ($popup) {
                        $($popup.associatedOverlay).remove();
                        $smartModal.destroyModal({ $view: element });
                    }
                });
            },
            templateUrl: 'shared/directives/uiElements/smartPopUp/smartPopUpTemplate.html'
        };
    }])
    .factory("$scoper", function () {
        return {
            getScope: function (scope, deep) {
                if (deep) {
                    var a, b = deep.split(".");
                    var bLength = b.length;
                    if (bLength > 1) {
                        a = scope;
                        for (var i = 0; i < bLength; i++) {
                            var sortCn = b[i].match(/(\[\d+\])+$/);
                            if (sortCn && sortCn.length > 0) {
                                var subScope = b[i].substr(0, b[i].indexOf('['));
                                a = a[subScope];
                                sortCn = sortCn[0].replace(/\]\[/g, ',').replace(/[\[\]]/g, '').split(",");
                                for (var j = 0; j < sortCn.length; j++) {
                                    a = a[sortCn[j]];
                                }
                            } else {
                                a = a[b[i]];
                            };
                        }
                    } else {
                        a = scope[deep];
                    }
                }
                return a;
            }
        };
    })
    .service("$smartModal", ["$timeout", "$compile", function ($timeout, $compile) {
        var _this = this;

        _this.open = function (config) {
            _this.initModal(config);
        }

        _this.initModal = function (config) {
            var attrs = [
                "show='{{" + (config.show || "") + "}}'",
                "popup-config='" + (config.$config || "") + "'",
                "on-hide='" + (config.onHide || "") + "'",
                "after-complete-close-popup='{{" + (config.afterCompleteClosePopup || "") + "}}'",
                "cancel-button='" + (config.cancelButton || "") + "'",
                "template-url='" + (config.templateUrl || "") + "'",
                "header-url='" + (config.headerUrl || "") + "'",
                "content-url='" + (config.contentUrl || "") + "'",
                "footer-url='" + (config.footerUrl || "") + "'",
                "type='" + (config.type || "") + "'",
                "is-draggable='" + (config.isDraggable || "") + "'",
                "expand-collapse='" + (config.expandCollapse || "") + "'",
                "dismissible='" + (config.dismissible || "") + "'"
            ]
                , smartpopDir = '<smart-popup ' + attrs.join(" ") + '> </smart-popup>';

            var popup = $compile(smartpopDir)(config.$scope);
            popup.appendTo("body");
        }

        _this.destroyModal = function (modal) { // this method invoke automatically once popup goes hide and also executed on scope $destroy.
            modal.$view && modal.$view.remove();
            modal.$scope && modal.$scope.$destroy();
        }
    }]);
})();